module.exports = __webpack_public_path__ + "img/little-symmetry-bad.6fab57fc.svg";